import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Preloader from "../components/Preloader";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";

const TEAM_API = "https://backenddev.aaerlaw.com/api/user/team_members";
const SERVER = "https://backenddev.aaerlaw.com";

function TeamDetails() {
  const location = useLocation();
  const id = new URLSearchParams(location.search).get("id");

  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";

    if (!id) { setNotFound(true); setLoading(false); return; }

    fetch(`${TEAM_API}/${id}`)
      .then((res) => {
        if (!res.ok) throw new Error("not found");
        return res.json();
      })
      .then((json) => setMember(json))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  const fullName = (m) =>
    [m.title, m.first_name, m.middle_name, m.last_name].filter(Boolean).join(" ");

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb Section */}
      <div
        className="breadcrumb-section breadcrumb-compact bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              {member ? fullName(member) : "Team Member"}
            </h2>
            <ul
              className="list-unstyled wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="1000ms"
            >
              <li>
                <Link className="magnet-link" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link className="magnet-link" to="/team">
                  Team
                </Link>
              </li>
              {member && <li>{fullName(member)}</li>}
            </ul>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Team Member Details */}
      <div className="team-member-details bg-white">
        <div className="divider"></div>

        <div className="container">
          {loading ? (
            <div className="text-center py-5">
              <span>Loading…</span>
            </div>
          ) : notFound || !member ? (
            <div className="text-center py-5">
              <p>Team member not found.</p>
              <Link to="/team" className="btn btn-primary">
                <span>Back to Team <i className="ti ti-arrow-up-right"></i></span>
                <span>Back to Team <i className="ti ti-arrow-up-right"></i></span>
              </Link>
            </div>
          ) : (
            <div className="row g-5">
              <div className="col-12 col-md-5">
                <div className="team-details-img pe-xl-5">
                  <img
                    src={
                      member.profile_image
                        ? `${SERVER}/${member.profile_image}`
                        : "assets/img/bg-img/10.jpg"
                    }
                    alt={fullName(member)}
                    style={{ width: "100%", objectFit: "cover" }}
                  />
                </div>
              </div>

              <div className="col-12 col-md-7">
                <div className="team-details-content">
                  <h2 className="team-member-title mb-2">{fullName(member)}</h2>
                  <p className="h4 mb-4 text-primary">{member.position}</p>

                  {member.summary && (
                    <p className="mb-4">{member.summary}</p>
                  )}

                  {member.description && (
                    <>
                      <div className="h4 mb-3">About</div>
                      <div
                        className="mb-5"
                        dangerouslySetInnerHTML={{ __html: member.description }}
                      />
                    </>
                  )}

                  {/* Keep social links at the end of the profile text. */}
                  {(member.linkedin || member.twitter || member.facebook || member.instagram) && (
                    <div className="social-nav mb-4">
                      {member.linkedin && (
                        <a href={member.linkedin} target="_blank" rel="noreferrer">
                          <i className="ti ti-brand-linkedin"></i>
                        </a>
                      )}
                      {member.twitter && (
                        <a href={member.twitter} target="_blank" rel="noreferrer">
                          <i className="ti ti-brand-x"></i>
                        </a>
                      )}
                      {member.facebook && (
                        <a href={member.facebook} target="_blank" rel="noreferrer">
                          <i className="ti ti-brand-facebook"></i>
                        </a>
                      )}
                      {member.instagram && (
                        <a href={member.instagram} target="_blank" rel="noreferrer">
                          <i className="ti ti-brand-instagram"></i>
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="divider"></div>
      </div>

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}


export default TeamDetails;
